/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';

import * as LoadInfo from './loadInfo';
import * as Clear from './clear';
import * as RunOption from './runOption';

export default combineReducers({
  loadInfo: LoadInfo.default,
  runOption: RunOption.default,
});

export const Selectors = {
  loadInfo: LoadInfo.Selectors,
  runOption: RunOption.Selectors,
};

export const Creators = {
  loadInfo: LoadInfo.Creators,
  clear: Clear.Creators,
  runOption: RunOption.Creators,
};

export const sagas = [call(LoadInfo.saga), call(Clear.saga), call(RunOption.saga)];
